import React from "react"
import "semantic-ui-css/semantic.min.css"

const VerificationSelector = ({
  isVerificationSelectorFilterOpen,
  onVerificationSelectorClearFilter,
  onVerificationSelectorClose,
  onVerificationSelectorSelect,
  verificationSelectorSelectedFilter,
  verificationSelectorToggleFilter,
} = {}) => {
  return (
    <div>
      <button type="button" className="facetselector ui button" onClick={verificationSelectorToggleFilter}>
        <i className="paperclip icon" />
        Verification
      </button>
      {isVerificationSelectorFilterOpen && (
        <div className="filter-popup">
          <h4>Verification</h4>
          <div className="filter-options">
            <div
              className="selection"
              onClick={() => onVerificationSelectorSelect("All")}
              onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") onVerificationSelectorSelect("All") }}
              role="button"
              tabIndex="0"
            >
              <label htmlFor="all" className="label-filter-button">
                <input type="checkbox" name="all" />
                All
              </label>
            </div>
            <div
              className="selection"
              onClick={() => onVerificationSelectorSelect("Unreconciled transfer")}
              onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") onVerificationSelectorSelect("With Manually Proof Only") }}
              role="button"
              tabIndex="0"
            >
              <label className="label-filter-button" htmlFor="unreconciledTransfer">
                <input type="checkbox" name="unreconciledTransfer" />
                Unreconciled transfer
              </label>
            </div>
            <div
              className="selection"
              onClick={() => onVerificationSelectorSelect("Delta amount problems")}
              onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") onVerificationSelectorSelect("With Suggested Proof Only") }}
              role="button"
              tabIndex="0"
            >
              <label className="label-filter-button" htmlFor="deltaAmountProblems">
                <input type="checkbox" name="deltaAmountProblems" />
                Delta amount problems
              </label>
            </div>
            <button
              type="button"
              className="ui button"
              onClick={onVerificationSelectorClose}
              style={{ marginTop: "10px" }}
            >
              Cancel
            </button>
          </div>
        </div>
      )}
      {verificationSelectorSelectedFilter && (
        <div className="active-filter selected-active-filter">
          <span>
            {verificationSelectorSelectedFilter}
          </span>
          <button
            type="button"
            className="remove-filter"
            onClick={onVerificationSelectorClearFilter}
          >
            &times;
          </button>
        </div>
      )}
    </div>
  )
}
export default VerificationSelector
